/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';

export interface IPharmacyMiscBillItem {
  id?: string;
  chargedMrp?: number;
  qty?: number;
  active?: boolean;
  cursor?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  paidAmount?: number | null;
  gst?: number | null;
  chargeName?: string;
  pharmacyBill?: IPharmacyBill | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IPharmacyMiscBillItem> = {
  active: false,
};
